import axios from "axios";
// let url = "http://127.0.0.1:8000/api";

// Live 
let url = "https://artisan.projectsample.info/backend/public/api";

// Dev 
// let url = "https://artisan.projectsample.info/backend-development/public/api";

// Test 
// let url = "https://artisan.projectsample.info/backend-for-testing/public/api";




export default axios.create({
  url: url,
  baseURL: url,
  headers: {
    Accept: "application/json",
    // "Content-Type": "multipart/form-data",
    // Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
  },
});
